import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22script-font.ts%22,%22import%22:%22Great_Vibes%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22weight%22:%22400%22,%22display%22:%22swap%22,%22preload%22:false,%22fallback%22:[%22Brush%20Script%20MT%22,%22cursive%22]}],%22variableName%22:%22scriptFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Great Vibes', Brush Script MT, cursive",
        fontWeight: 400,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
